import React, { FC } from 'react';

interface Props {
  className?: string;
  size?: number;
  color?: string;
}

export const ReplyIcon: FC<Props> = ({ className, size = 20, color = 'currentColor' }) => {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M15.8333 15.8334V12.5C15.8333 11.8056 15.5903 11.2153 15.1042 10.7292C14.6181 10.2431 14.0278 10 13.3333 10H5.6875L8.6875 13L7.5 14.1667L2.5 9.16669L7.5 4.16669L8.6875 5.33335L5.6875 8.33335H13.3333C14.4861 8.33335 15.4688 8.7396 16.2812 9.5521C17.0938 10.3646 17.5 11.3472 17.5 12.5V15.8334H15.8333Z" />
    </svg>
  );
};
